import { gameDataMapper } from "../../../Composables";
import { getParticipantData } from "../../../Helpers";
import { Participant } from "../../../Constants";
export class AggregatedGameDataParser {
    static parse(aggregatedEvent, events) {
        return {
            aggregatedParticipants1: getParticipantData(aggregatedEvent, Participant.One),
            aggregatedParticipants2: getParticipantData(aggregatedEvent, Participant.Two),
            games: events.map(gameDataMapper)
        };
    }
}
//# sourceMappingURL=AggregatedGameDataParser.js.map